<div class="container-fluid py-2 header-wrapper sticky-top">
    <div class="home-link" (click)="onHeaderClicked()">
        <img [src]="logoLink" class="logo-image" alt="">
        <span class="title-text">Dorpelbestellen.nl</span>
    </div>
</div>
